<template>
<v-container grid-list-xl fluid>
    <v-layout row wrap>
        <v-flex lg12>
            <v-card>
                <hpo-filter :headers="headers" :viewName="viewName" :view_filters="view_filters" v-on:applyFilter="applyFilter" v-on:quickFilter="quickFilter"></hpo-filter>
                <v-data-table :headers="headers" :items="items" :options.sync="pagination" :server-items-length="total_rows" :footer-props="items_per_page" :must-sort="true" :loading="loading" :mobile-breakpoint="100">
                    <template v-slot:item="{ item }">
                        <tr>
                            <td>{{ item.UserName }}</td>
                            <td>{{ item.PartnerName }}</td>
                            <td>{{ item.ProductNameCN }}</td>
                            <td><p v-html="item.OrderCodes"></p></td>
                            <td><p v-html="item.BillCodes"></p></td>
                            <td>{{ item.Code }}</td>
                            <td>{{ item.SuffixBill }}</td>
                            <td class="text-right">
                                <v-tooltip right color="grey lighten-3" transition="expand-transition">
                                    <template v-slot:activator="{ on }">
                                        <span v-on="on">{{ item.Deposit | currency('', 2) }}</span>
                                    </template>
                                    <span>
                                    <v-list width="350" color="transparent">
                                        <v-list-item>
                                            <v-list-item-title>Ship nội địa: </v-list-item-title>
                                            <v-list-item-subtitle>{{item.TransactionDeposit | currency('¥', 2)}}</v-list-item-subtitle>
                                        </v-list-item>
                                        <v-list-item>
                                            <v-list-item-title>Chi xe kéo: </v-list-item-title>
                                            <v-list-item-subtitle>{{item.PedicabDeposit | currency('¥', 2)}}</v-list-item-subtitle>
                                        </v-list-item>
                                        <v-list-item>
                                            <v-list-item-title>Chi xe nâng: </v-list-item-title>
                                            <v-list-item-subtitle>{{item.LoadDeposit | currency('¥', 2)}}</v-list-item-subtitle>
                                        </v-list-item>
                                    </v-list>
                                    </span>
                                </v-tooltip>
                            </td>
                            <td class="text-right">{{ item.FeeCare | currency }}</td>
                            <td class="text-right">{{ item.Weight | currency('', 1) }}</td>
                            <td class="text-right">{{ item.Volume | currency('', 3) }}</td>
                            <td class="text-right">
                                <v-tooltip right color="grey lighten-3" transition="expand-transition">
                                    <template v-slot:activator="{ on }">
                                        <span v-on="on" v-if="currentPath.includes('ton-kho-tq')">{{ ((item.NumberOfPack | 0)-(item.NumberOfPackTruck | 0)) | currency }}</span>
                                        <span v-on="on" v-else-if="currentPath.includes('ton-kho-vn')">{{ ((item.NumberOfPackImport | 0)-(item.NumberOfPackExport | 0)) | currency }}</span>
                                        <span v-on="on" v-else>{{ item.NumberOfPack | currency }}</span>
                                    </template>
                                    <span>
                                    <v-list width="350" color="transparent">
                                        <v-list-item>
                                            <v-list-item-title>Tổng kiện: </v-list-item-title>
                                            <v-list-item-subtitle>{{item.NumberOfPack | currency}}</v-list-item-subtitle>
                                        </v-list-item>
                                        <v-list-item>
                                            <v-list-item-title>Đã xếp xe: </v-list-item-title>
                                            <v-list-item-subtitle>{{item.NumberOfPackTruck | currency}}</v-list-item-subtitle>
                                        </v-list-item>
                                        <v-list-item>
                                            <v-list-item-title>Nhập kho VN: </v-list-item-title>
                                            <v-list-item-subtitle>{{item.NumberOfPackImport | currency}}</v-list-item-subtitle>
                                        </v-list-item>
                                        <v-list-item>
                                            <v-list-item-title>Xuất kho VN: </v-list-item-title>
                                            <v-list-item-subtitle>{{item.NumberOfPackExport | currency}}</v-list-item-subtitle>
                                        </v-list-item>
                                    </v-list>
                                    </span>
                                </v-tooltip>
                            </td>
                            <td>
                                {{ item.ReceiveDate | display_date('DD-MM-YYYY')}}
                                <br />
                                {{ item.PackDate | display_date('DD-MM-YYYY')}}
                            </td>
                            <td>
                                {{ item.DeliverDate | display_date('DD-MM-YYYY')}}
                                <br />
                                {{ item.PaymentDate | display_date('DD-MM-YYYY')}}
                            </td>
                            <td>{{ item.Status | display_value(product_status_list) }}</td>
                            <td class="text-center">         
                                <v-icon medium class="mr-2" @click="openItem(item.ID)">{{ !adminRole ? 'visibility' : 'edit' }}</v-icon>
                                <v-icon medium @click="deleteItem(item.ID)" v-if="adminRole">delete</v-icon>
                            </td>
                        </tr>
                    </template>
                    <template v-slot:body.append v-if="summary">
                        <tr class="total-summary-td">
                            <td colspan="7" class="text-center font-weight-bold">Tổng</td>
                            <td class="text-end font-weight-bold">{{ summary.Deposit | currency('', 2)}}</td>
                            <td class="text-end font-weight-bold">{{ summary.FeeCare | currency}}</td>
                            <td class="text-end font-weight-bold">{{ summary.Weight | currency('', 1)}}</td>
                            <td class="text-end font-weight-bold">{{ summary.Volume | currency('', 3)}}</td>
                            <td class="text-end font-weight-bold">{{ summary.NumberOfPack | currency}}</td>
                            <td></td>
                            <td></td>
                            <td></td>
                            <td></td>
                        </tr>
                    </template>
                </v-data-table>
            </v-card>
        </v-flex>
    </v-layout>
    <v-dialog v-model="dialogItem" max-width="800px">
        <v-form ref="edit_form" lazy-validation>
            <v-card>
                <v-card-actions>
                    <span class="title">Chi tiết mã vận đơn</span>
                    <v-spacer></v-spacer>
                    <v-btn color="red darken-1 white--text" @click="dialogItem = false">Đóng</v-btn>
                    <v-btn @click="editItem" v-if="adminRole">Lưu lại</v-btn>
                </v-card-actions>
                <v-card-text>
                    <v-container grid-list-md pa-0>
                        <v-layout row wrap>
                            <v-flex lg6>
                                <v-autocomplete v-model="currentItem.UID" :items="customers" item-value="ID" item-text="Username" label="Chọn khách hàng" autocomplete="off"></v-autocomplete>
                            </v-flex>
                            <v-flex lg6>
                                <v-autocomplete v-model="currentItem.StoreID" :items="storages" item-value="ID" item-text="Name" label="Kho nhận" autocomplete="off"></v-autocomplete>
                            </v-flex>
                            <v-flex lg12>
                                <v-text-field label="Tên khách" v-model="currentItem.PartnerName"></v-text-field>
                            </v-flex>
                            <v-flex lg6>
                                <v-text-field label="Tên sản phẩm" v-model="currentItem.ProductNameCN"></v-text-field>
                            </v-flex>
                            <v-flex lg6>
                                <v-autocomplete v-model="currentItem.ProductType" :items="product_types" item-value="ID" item-text="Name" label="Loại hàng" autocomplete="off"></v-autocomplete>
                            </v-flex>
                            <v-flex lg6>
                                <v-text-field label="Mã vào kho" v-model="currentItem.Code"></v-text-field>
                            </v-flex>
                            <v-flex lg6>
                                <v-text-field label="Mã vận đơn" v-model="currentItem.SuffixBill"></v-text-field>
                            </v-flex>
                            <v-flex lg3>
                                <h-currency-input label="Ship nội địa (¥)" v-model="currentItem.TransactionDeposit" :decimal="2" class="input-group--focused"></h-currency-input>
                            </v-flex>
                            <v-flex lg3>
                                <h-currency-input label="Chi xe kéo (¥)" v-model="currentItem.PedicabDeposit" :decimal="2" class="input-group--focused"></h-currency-input>
                            </v-flex>
                            <v-flex lg3>
                                <h-currency-input label="Chi xe nâng (¥)" v-model="currentItem.LoadDeposit" :decimal="2" class="input-group--focused"></h-currency-input>
                            </v-flex>
                            <v-flex lg3>
                                <h-currency-input label="Tỷ giá" v-model="currentItem.ExchangeRate" :decimal="0" class="input-group--focused"></h-currency-input>
                            </v-flex>
                            <v-flex lg3>
                                <h-currency-input label="Tổng cân" v-model="currentItem.Weight" :decimal="1" class="input-group--focused"></h-currency-input>
                            </v-flex>
                            <v-flex lg3>
                                <h-currency-input label="Tổng khối" v-model="currentItem.Volume" :decimal="3" class="input-group--focused"></h-currency-input>
                            </v-flex>
                            <v-flex lg3>
                                <h-currency-input label="Tổng kiện" v-model="currentItem.NumberOfPack" :decimal="0" class="input-group--focused"></h-currency-input>
                            </v-flex>
                            <v-flex lg3>
                                <h-currency-input label="Phí bảo hiểm" v-model="currentItem.FeeCare" :decimal="0" class="input-group--focused"></h-currency-input>
                            </v-flex>
                            <v-flex lg4>
                                <v-autocomplete v-model="currentItem.PriceType" :items="price_types" item-value="value" item-text="name" label="Cách tính phí" autocomplete="off" :disabled="!adminRole"></v-autocomplete>
                            </v-flex>
                            <v-flex lg4>
                                <h-currency-input label="Giá cân" v-model="currentItem.WeightPrice" :decimal="0" class="input-group--focused" :disabled="!adminRole"></h-currency-input>
                            </v-flex>
                            <v-flex lg4>
                                <h-currency-input label="Giá khối" v-model="currentItem.VolumePrice" :decimal="0" class="input-group--focused" :disabled="!adminRole"></h-currency-input>
                            </v-flex>
                            <v-flex lg12 md12 sm12 v-if="adminRole">
                                <v-layout row wrap justify-end>
                                    <v-btn class="mx-2" dark small color="red" @click="addSubItem" :disabled="readOnly"><v-icon dark>add</v-icon></v-btn>
                                </v-layout>
                            </v-flex>
                        </v-layout>
                        <v-layout pt-2>
                            <v-flex lg12 md12 sm12>
                                <v-data-table
                                :must-sort="false"
                                :headers="sub_headers"
                                :items="currentPackages"
                                hide-default-footer
                                disable-pagination
                                >
                                <template v-slot:item="{ item, index }">
                                    <tr>
                                        <td class="text-end" v-if="readOnly">{{ item.Length | currency }}</td>
                                        <td class="text-end" v-else>
                                            <v-edit-dialog
                                            :return-value.sync="item.Length"
                                            large
                                            lazy
                                            persistent
                                            @save="updateSubItem"
                                            >
                                            <div>{{ item.Length | currency }}</div>
                                            <template v-slot:input>
                                                <h-currency-input
                                                v-model="item.Length"
                                                :decimal="0"
                                                label="Chiều dài (cm)"
                                                autofocus
                                                ></h-currency-input>
                                            </template>
                                            </v-edit-dialog>
                                        </td>
                                        <td class="text-end" v-if="readOnly">{{ item.Width | currency }}</td>
                                        <td class="text-end" v-else>
                                            <v-edit-dialog
                                            :return-value.sync="item.Width"
                                            large
                                            lazy
                                            persistent
                                            @save="updateSubItem"
                                            >
                                            <div>{{ item.Width | currency }}</div>
                                            <template v-slot:input>
                                                <h-currency-input
                                                v-model="item.Width"
                                                :decimal="0"
                                                label="Chiều rộng (cm)"
                                                autofocus
                                                ></h-currency-input>
                                            </template>
                                            </v-edit-dialog>
                                        </td>
                                        <td class="text-end" v-if="readOnly">{{ item.Height | currency }}</td>
                                        <td class="text-end" v-else>
                                            <v-edit-dialog
                                            :return-value.sync="item.Height"
                                            large
                                            lazy
                                            persistent
                                            @save="updateSubItem"
                                            >
                                            <div>{{ item.Height | currency }}</div>
                                            <template v-slot:input>
                                                <h-currency-input
                                                v-model="item.Height"
                                                :decimal="0"
                                                label="Chiều cao (cm)"
                                                autofocus
                                                ></h-currency-input>
                                            </template>
                                            </v-edit-dialog>
                                        </td>
                                        <td class="text-end" v-if="readOnly">{{ item.Weight | currency('', 1) }}</td>
                                        <td class="text-end" v-else>
                                            <v-edit-dialog
                                            :return-value.sync="item.Weight"
                                            large
                                            lazy
                                            persistent
                                            @save="updateSubItem"
                                            >
                                            <div>{{ item.Weight | currency('', 1) }}</div>
                                            <template v-slot:input>
                                                <h-currency-input
                                                v-model="item.Weight"
                                                :decimal="1"
                                                label="Cân nặng (kg)"
                                                autofocus
                                                ></h-currency-input>
                                            </template>
                                            </v-edit-dialog>
                                        </td>
                                        <td class="text-end" v-if="readOnly">{{ item.NumberOfPack | currency }}</td>
                                        <td class="text-end" v-else>
                                            <v-edit-dialog
                                            :return-value.sync="item.NumberOfPack"
                                            large
                                            lazy
                                            persistent
                                            @save="updateSubItem"
                                            >
                                            <div>{{ item.NumberOfPack | currency }}</div>
                                            <template v-slot:input>
                                                <h-currency-input
                                                v-model="item.NumberOfPack"
                                                :decimal="0"
                                                label="Số kiện"
                                                autofocus
                                                ></h-currency-input>
                                            </template>
                                            </v-edit-dialog>
                                        </td>
                                        <td class="text-center">
                                            <v-icon small @click="deleteSubItem(index)" v-if="!readOnly">delete</v-icon>
                                        </td>
                                    </tr>
                                </template>
                                </v-data-table>
                            </v-flex>
                        </v-layout>
                        <v-layout row wrap>
                            <v-flex lg12>
                                <v-text-field label="Ghi chú" v-model="currentItem.Note"></v-text-field>
                            </v-flex>
                            <v-flex lg12 v-if="adminRole">
                                <p class="v-label">Hình ảnh</p>
                                <input v-if="!uploading" type="file" ref="fileInput" @change="uploadFile" > 
                                <v-progress-circular v-if="uploading > 0" indeterminate size="32"></v-progress-circular>
                            </v-flex>
                            <v-flex lg12 md12 sm12 xs12>
                                <template v-for="(f, index) in files">
                                    <v-tooltip v-bind:key="f.url" top>
                                        <template v-slot:activator="{ on }">
                                            <v-chip v-on="on" class="ma-2" close color="green" outlined  @click:close="fileRemove(index)" @click="fileOpen(f)">{{f.name}}</v-chip>
                                        </template>
                                        <v-img :src="f.url" max-width="250"></v-img>
                                    </v-tooltip>
                                </template>
                            </v-flex>
                        </v-layout>
                    </v-container>
                </v-card-text>
            </v-card>
        </v-form>
    </v-dialog>
    <upload-file :dialogUpload="dialogImport" title="Import mã vận đơn" temp_file="/ma_van_don_mau.xls" @closePopup="dialogImport=false" @importFile="importFile"></upload-file>
</v-container>
</template>

<script>
import { mapState } from "vuex";
import configs from "@/configs";
import Filtering from "@/components/Filtering";
import { sendErrorNotice, makeid } from "@/commons/utils";
import firebase from 'firebase';
import upload_file from "@/components/popups/upload_file";
import moment from 'moment';
import _ from "lodash";

export default {
    components: {
        "hpo-filter": Filtering,
        "upload-file": upload_file,
    },
    data() {
        return {
            viewName: "product_list",
            view_filters: [],
            dialogItem: false,
            dialogImport: false,
            receive_type_list: configs.RECEIVE_TYPE_LIST,
            receive_type: configs.RECEIVE_TYPE,
            product_status_list: configs.PRODUCT_STATUS_LIST,
            product_status: configs.PRODUCT_STATUS,
            price_types: configs.PRICE_TYPE_LIST,
            sub_headers: [
                {
                  text: "Dài",
                  value: "Length",
                  sortable: false,
                  align: "end",
                },
                {
                  text: "Rộng",
                  value: "Width",
                  sortable: false,
                  align: "end",
                },
                {
                  text: "Cao",
                  value: "Height",
                  sortable: false,
                  align: "end",
                },
                {
                  text: "Cân nặng",
                  value: "Weight",
                  sortable: false,
                  align: "end",
                },
                {
                    text: "Số kiện",
                    value: "NumberOfPack",
                    sortable: false,
                    align: "end",
                },
                {
                    text: "",
                    width: "40px",
                    align: "center",
                },
            ],
            pagination: {...configs.PAGINATION},
            items_per_page: {...configs.ITEMS_PER_PAGE},
            filterConditions: [],
            quickFilterConditions: [],
            requireRules: [v => !!v || "Trường dữ liệu không được để trống."],
            receiveDate: null,
            packDate: null,
            deliverDate: null,
            paymentDate: null,
            files: [],
            uploading: 0,
            pendingUploads: [],
            currentPackages: [],
        };
    },
    watch: {
        pagination: {
            handler: function (val, oldVal) {
                let filterConditions = this.$store.state.commons.filterConditions;
                this.filterConditions = !_.isEmpty(filterConditions) ? filterConditions[this.viewName] : []
                this.filter_data();
            },
            deep: true
        },
        currentItem() {
            this.receiveDate = this.currentItem.ReceiveDate ? moment(this.currentItem.ReceiveDate).toISOString().substr(0, 10) : null;
            this.packDate = this.currentItem.PackDate ? moment(this.currentItem.PackDate).toISOString().substr(0, 10) : null;
            this.deliverDate = this.currentItem.DeliverDate ? moment(this.currentItem.DeliverDate).toISOString().substr(0, 10) : null;
            this.paymentDate = this.currentItem.PaymentDate ? moment(this.currentItem.PaymentDate).toISOString().substr(0, 10) : null;
            this.files = this.currentItem.Images ? JSON.parse(this.currentItem.Images) : [];
            this.currentPackages = this.currentItem && this.currentItem.Packages ? JSON.parse(this.currentItem.Packages) : [];
        },
        currentPath() {
            this.view_filters = [];
            this.filterConditions = [];
            this.quickFilterConditions = [];
            this.filter_data();
        },
        adminRole() {
            this.$root.$emit('REQUEST_ROOT_OPTION', {invisibleCreateButton: !this.adminRole, invisibleImportButton: !this.adminRole});
        }
    },
    computed: {
        ...mapState({
            items: state => state.product.all.data,
            total_rows: state => state.product.all.total,
            summary: state => state.product.all.summary,
            loading: state => state.product.loading,
            currentItem: state => state.product.selected,
            customers: state => state.commons.customers,
            storages: state => state.storage.all.data,
            product_types: state => state.productType.all.data,
        }),
        staffStorage() {
            return this.$store.state.authentication.user.storageid;
        },
        adminRole() {
            return this.$store.state.authentication.user.roleid == configs.ROLE_TYPE.Admin || this.$store.state.authentication.user.roleid == configs.ROLE_TYPE.Accountant;
        },
        roleCustomer() {
            return this.$store.state.authentication.user.roleid == configs.ROLE_TYPE.Customer;
        },
        readOnly() {
            return this.currentItem && this.currentItem.ID > 0 && this.currentItem.Status != this.product_status.nhap_kho_tq;
        },
        currentPath() {
            return this.$route.path !== undefined && this.$route.path ? this.$route.path : '';
        },
        isNoneOwner() {
            return this.currentPath.includes('hang-khong-ten');
        },
        headers() {
            return [{
                    text: "Mã KH",
                    value: "UserName",
                    filterable: true,
                    quickSearch: true,
                    dataType: configs.DATA_TYPE["String"]
                },
                {
                    text: "Tên khách",
                    value: "PartnerName",
                    filterable: true,
                    quickSearch: true,
                    dataType: configs.DATA_TYPE["String"]
                },
                {
                    text: "Tên hàng",
                    value: "ProductNameCN",
                    filterable: true,
                    dataType: configs.DATA_TYPE["String"]
                },
                {
                    text: "Xếp xe",
                    value: "OrderCodes",
                    filterable: true,
                    quickSearch: true,
                    dataType: configs.DATA_TYPE["String"]
                },
                {
                    text: "Xuất kho",
                    value: "BillCodes",
                    filterable: true,
                    quickSearch: true,
                    dataType: configs.DATA_TYPE["String"]
                },
                {
                    text: "Mã vào kho",
                    value: "Code",
                    filterable: true,
                    quickSearch: true,
                    dataType: configs.DATA_TYPE["String"]
                },
                {
                    text: "Mã vận đơn",
                    value: "SuffixBill",
                    filterable: true,
                    dataType: configs.DATA_TYPE["String"]
                },
                {
                    text: "Tổng chi (¥)",
                    value: "Deposit",
                    align: "end",
                    filterable: true,
                    dataType: configs.DATA_TYPE["Number"]
                },
                {
                    text: "Bảo hiểm",
                    value: "FeeCare",
                    align: "end",
                    filterable: true,
                    dataType: configs.DATA_TYPE["Number"]
                },
                {
                    text: "Cân nặng",
                    value: "Weight",
                    align: "end",
                    filterable: true,
                    dataType: configs.DATA_TYPE["Number"]
                },
                {
                    text: "Thể tích",
                    value: "Volume",
                    align: "end",
                    filterable: true,
                    dataType: configs.DATA_TYPE["Number"]
                },
                {
                    text: this.currentPath.includes('ton-kho-tq') || this.currentPath.includes('ton-kho-vn') ? "Kiện tồn" : "Tổng kiện",
                    value: "NumberOfPack",
                    align: "end",
                    filterable: true,
                    dataType: configs.DATA_TYPE["Number"]
                },
                {
                    text: "Nhập kho TQ",
                    value: "ReceiveDate",
                    dataType: configs.DATA_TYPE["Date"]
                },
                {
                    text: "Xuất kho VN",
                    value: "DeliverDate",
                    dataType: configs.DATA_TYPE["Date"]
                },
                {
                    text: "Trạng thái",
                    value: "Status",
                    filterable: true,
                    values: configs.PRODUCT_STATUS_LIST,
                    dataType: configs.DATA_TYPE["Enum"]
                },
                {
                    text: "",
                    value: "",
                    align: "center",
                    width: "80px"
                }
            ];
        } 
    },
    methods: {
        filter_data: function () {
            var param = {
                pagination: this.pagination,
                filter: this.filterConditions,
                quickFilter: this.quickFilterConditions
            };
            if(this.currentPath.includes('hang-khong-ten')) {
                param.filter.push({
                    column: "UID",
                    value: 0,
                    condition: "equal",
                });
                param.action = "hang-khong-ten";
            }
            else if(this.currentPath.includes('nhap-kho-tq')) {
                param.filter.push({
                    column: "Status",
                    value: [this.product_status.nhap_kho_tq, this.product_status.xep_xe, this.product_status.nhap_kho_vn, this.product_status.xuat_thieu, this.product_status.xuat_du],
                    condition: "in",
                });
            }
            else if(this.currentPath.includes('hang-da-xep-xe')) {
                param.filter.push({
                    column: "Status",
                    value: [this.product_status.xep_xe, this.product_status.nhap_kho_vn, this.product_status.xuat_thieu, this.product_status.xuat_du],
                    condition: "in",
                });
            }
            else if(this.currentPath.includes('nhap-kho-vn')) {
                param.filter.push({
                    column: "Status",
                    value: [this.product_status.nhap_kho_vn, this.product_status.xuat_thieu, this.product_status.xuat_du],
                    condition: "in",
                });
            }
            else if(this.currentPath.includes('xuat-kho-vn')) {
                param.filter.push({
                    column: "Status",
                    value: [this.product_status.xuat_thieu, this.product_status.xuat_du],
                    condition: "in",
                });
            }
            else if(this.currentPath.includes('ton-kho-tq')) {
                param.action = "ton-kho-tq";
            }
            else if(this.currentPath.includes('ton-kho-vn')) {
                param.filter.push({
                    column: "Status",
                    value: [this.product_status.nhap_kho_vn, this.product_status.xuat_thieu],
                    condition: "in",
                });
                param.action = "ton-kho-vn";
            }
            this.$store.dispatch("product/getList", param);
            if(this.dialogItem && this.currentItem.ID > 0) {
                this.$store.dispatch("product/getDetail", this.currentItem.ID);
            }
        },
        applyFilter(filterConditions) {
            let sortBy = this.pagination.sortBy
            let sortDesc = this.pagination.sortDesc
            this.pagination = configs.PAGINATION;
            this.pagination.sortBy = sortBy;
            this.pagination.sortDesc = sortDesc;
            this.filterConditions = filterConditions;
            this.filter_data();
        },
        quickFilter(filterConditions) {
            this.quickFilterConditions = filterConditions;
            this.filter_data();
        },
        openItem: function (id) {
            if(!id) {
                this.$store.commit("product/setDetail", {'ID': id, 'StoreID': this.staffStorage});
            }
            else {
                this.$store.dispatch("product/getDetail", id);
            }
            this.dialogItem = true;
        },
        deleteItem: function(id) {
            window.getApp.$emit('REQUEST_DELETE_DATA', id);
        },
        async editItem() {
            if(this.$refs.edit_form.validate()) {
                await this.uploadPendingFiles();
                let selectedCustomer = _.find(this.customers, {'ID': this.currentItem.UID});
                this.$store.dispatch("product/setDetail", {
                    'data': {
                        ...this.currentItem,
                        Packages: this.currentPackages.length > 0 ? JSON.stringify(this.currentPackages) : null,
                        ReceiveDate: this.receiveDate ? moment(this.receiveDate, 'YYYY-MM-DD').format(configs.SQL_DATE_FORMAT) : null,
                        PackDate: this.packDate ? moment(this.packDate, 'YYYY-MM-DD').format(configs.SQL_DATE_FORMAT) : null,
                        DeliverDate: this.deliverDate ? moment(this.deliverDate, 'YYYY-MM-DD').format(configs.SQL_DATE_FORMAT) : null,
                        PaymentDate: this.paymentDate ? moment(this.paymentDate, 'YYYY-MM-DD').format(configs.SQL_DATE_FORMAT) : null,
                        UserName: selectedCustomer ? selectedCustomer.Username : this.currentItem.Username,
                        Status: this.currentItem.ID > 0 ? this.currentItem.Status : this.product_status.nhap_kho_tq,
                        Images: JSON.stringify(this.files),
                    },
                    'id': this.currentItem.ID
                });
                this.dialogItem = false;
            }
        },
        addSubItem() {
            let split_packages = [...this.currentPackages];
            split_packages.push({'Length': 0, 'Width': 0, 'Height': 0, 'Weight': 0, 'NumberOfPack': 0});
            this.currentItem.Packages = JSON.stringify(split_packages);
            this.currentPackages = this.currentItem && this.currentItem.Packages ? JSON.parse(this.currentItem.Packages) : [];
            if(this.currentItem.ID > 0) {
                this.$store.dispatch("product/setDetail", {
                    data: {
                        Packages: this.currentItem.Packages,
                    },
                    id: this.currentItem.ID,
                });
            }
        },
        deleteSubItem(index) {
            let split_packages = [...this.currentPackages];
            split_packages.splice(index, 1);
            this.currentItem.Packages = JSON.stringify(split_packages);
            this.currentPackages = this.currentItem && this.currentItem.Packages ? JSON.parse(this.currentItem.Packages) : [];
            if(this.currentItem.ID > 0) {
                this.$store.dispatch("product/setDetail", {
                    data: {
                        Packages: this.currentItem.Packages,
                    },
                    id: this.currentItem.ID,
                });
            }
        },
        updateSubItem() {
            this.currentItem.Packages = JSON.stringify(this.currentPackages);
            if(this.currentItem.ID > 0) {
                this.$store.dispatch("product/setDetail", {
                    data: {
                        Packages: this.currentItem.Packages,
                    },
                    id: this.currentItem.ID,
                });
            }
        },
        fileOpen(f) {
            window.open(f.url, 'blank');
        },
        fileRemove(index) {
            // firebase.storage().refFromURL(this.files[index].url).delete();
            this.files.splice(index, 1);
        },
        uploadFile(e) {
            const file = e.target.files[0];
            this.pendingUploads.push(file);
            this.files.push({'local': 1, 'name': file.name, 'url': URL.createObjectURL(file)});
            this.$refs.fileInput.value = null;
        },
        timer(ms) { return new Promise(res => setTimeout(res, ms)); },
        async uploadPendingFiles() {
            this.files = _.filter(this.files, (p) => {return p.local !== 1});
            this.uploading = this.pendingUploads.length;
            for (let index = 0; index < this.pendingUploads.length; index++) {
                const file = this.pendingUploads[index];
                const arrFileType = file.name.split('.');
                const ext = arrFileType[arrFileType.length - 1];
                if (['jpg','png','jpeg'].indexOf(ext) === -1) {
                    sendErrorNotice('File không đúng định dạng!');
                    return;
                }
                const storageRef=firebase.storage().ref(`${configs.SYSTEM_CONFIG.firebase_prefix}/bill/${makeid(30)}.${ext}`).put(file);
                storageRef.on(`state_changed`, snapshot => {
                        
                    },
                    error => {
                        sendErrorNotice('Lỗi upload file!');
                        this.uploading = this.uploading - 1;
                    },
                    () => {
                        storageRef.snapshot.ref.getDownloadURL().then((url) => {
                            this.files.push({'name': file.name, 'url': url});
                            this.uploading = this.uploading - 1;
                        });
                    }
                );
            }
            while (this.uploading > 0) {
                await this.timer(1000);
            }
        },
        importFileDialog() {
            this.dialogImport = true;
        },
        importFile(filelist) {
            for(const f of filelist) {
                const formData = new FormData();
                formData.append('excel_file', f);
                formData.append('filename', f.name);
                this.$store.dispatch("product/import_data", formData);
            }
            this.dialogImport = false;
        },
        exportData() {
            var param = {
                pagination: this.pagination,
                filter: this.filterConditions,
                quickFilter: this.quickFilterConditions
            };
            this.$store.dispatch("product/exportList", param);
        }
    },
    mounted() {
        this.$root.$emit('REQUEST_ROOT_OPTION', {invisibleCreateButton: !this.adminRole, invisibleImportButton: !this.adminRole});
        this.$store.dispatch("commons/getAllCustomer");
        this.$store.dispatch("storage/getList");
        this.$store.dispatch("productType/getList");
        this.$root.$on("REQUEST_CREATE_DATA", this.openItem);
        this.$root.$on("REQUEST_REFRESH_DATA", this.filter_data);
        this.$root.$on("REQUEST_IMPORT_ACTION", this.importFileDialog);
        this.$root.$on("CONFIRMED_REMOVE_DATA", id => {
            this.$store.dispatch("product/removeDetail", id);
        });
        this.$root.$on("REQUEST_EXPORT_ACTION", this.exportData);
    },
    beforeDestroy() {
        this.$root.$off("REQUEST_CREATE_DATA");
        this.$root.$off("REQUEST_REFRESH_DATA");
        this.$root.$off("CONFIRMED_REMOVE_DATA");
        this.$root.$off("REQUEST_IMPORT_ACTION");
        this.$root.$off("REQUEST_EXPORT_ACTION");
    }
};
</script>
